import { useContext, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client/react';
import * as R from 'ramda';

import { GET_ASSET_REQUESTS } from '@atom/graph/assetRequest';
import { AssetRequestStatus } from '@atom/types/assetRequest';
import { isPendingRequestCheckEnabled } from '@atom/utilities/tenantFeatureUtilities';

import CreateRequest from './createRequest/CreateRequest';
import RequestsContext from './RequestsContext';

import classes from './requestsTab.module.css';

const RequestsHeader = () => {
  const { totalCount, asset } = useContext(RequestsContext);

  const [getAssetRequests, { data, loading: assetRequestsLoading }] =
    useLazyQuery(GET_ASSET_REQUESTS, {
      fetchPolicy: 'network-only',
    });

  useEffect(() => {
    if (isPendingRequestCheckEnabled) {
      getAssetRequests({
        variables: {
          input: {
            page: 1,
            limit: 1,
            assetId: asset?.id,
            statuses: [
              AssetRequestStatus.PENDING_APPROVAL,
              AssetRequestStatus.PENDING_REVIEW,
            ],
          },
        },
      });
    }
  }, [totalCount]);

  const pendingCount = R.pathOr(0, ['assetRequests', 'totalCount'], data);
  const showCreate = !assetRequestsLoading && pendingCount === 0;

  return (
    <div className={classes.requestsHeader}>
      <div>{`${totalCount} Requests`}</div>
      {showCreate && <CreateRequest />}
    </div>
  );
};

export default RequestsHeader;
